<template>
  <div class="tw-relative tw-hidden tw-aspect-video tw-h-[65px] lg:tw-flex">
    <div
      v-if="['PROGRESSING', 'SUBMITTED'].includes(videoAsset.status)"
      class="tw-flex tw-h-full tw-w-full tw-flex-col tw-items-center tw-justify-center tw-rounded-lg tw-bg-muted tw-text-center tw-text-slate-400"
    >
      <TablerLoader2 class="tw-h-4 tw-w-4 tw-animate-spin" />
    </div>
    <img
      v-else-if="!thumbnailError"
      class="tw-h-full tw-w-full tw-rounded-lg tw-bg-slate-100 tw-object-contain"
      data-testid="video-library-item-thumbnail-img"
      :src="videoAsset.urls.thumbnail"
      @error="onThumbnailError"
    />
    <div
      v-else
      class="tw-aspect-video tw-h-full tw-overflow-hidden tw-rounded-lg tw-bg-slate-100 tw-object-cover dark:tw-bg-slate-700"
      data-testid="video-library-item-thumbnail-error"
    />
    <div
      class="tw-absolute tw-bottom-0 tw-flex tw-w-full tw-justify-center tw-rounded-b-lg tw-bg-black/70 tw-p-1 tw-text-center tw-text-2xs tw-text-slate-100"
      data-testid="video-library-item-duration"
    >
      {{ videoDuration }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';

import { VideoAsset } from '../videoLibraryService';

import TablerLoader2 from '@/studioComponents/Icons/tabler/TablerLoader2.vue';

const props = defineProps<{
  videoAsset: VideoAsset;
}>();

const thumbnailError = ref(false);

const onThumbnailError = () => {
  thumbnailError.value = true;
};

const videoDuration = computed(() => {
  if (props.videoAsset.duration.split(':')[0] === '00') {
    return props.videoAsset.duration.split(':').slice(1).join(':');
  }
  return props.videoAsset.duration;
});
</script>
